module.exports = __webpack_public_path__ + "img/banner_a.00a14b5a.jpg";